export default "__VITE_ASSET__D07Eq63F__"